import styled from 'styled-components';
import { Box } from '@rsos/base-components';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';

interface TooltipChildProps {
  overlapCompensation?: number;
}

export const TooltipChild = styled(Box).attrs(() => ({
  position: 'absolute',
  color: 'background',
  bg: 'primaryText',
  borderRadius: '5px',
  p: '10px',
}))<TooltipChildProps>`
  ${({ overlapCompensation }) => `
  width: max-content;
  display: flex;
  visibility: hidden;
  white-space: nowrap;
  z-index: 3;
  transform: translateX(calc(-50% - ${overlapCompensation}px));
  `}
`;

interface TooltipPortalProps {
  placement?: string;
}

export const TooltipPortal = styled(Box).attrs(() => ({
  position: 'fixed',
  color: 'background',
  bg: 'primaryText',
  borderRadius: '5px',
  p: '10px',
}))<TooltipPortalProps>`
  width: max-content;
  display: flex;
  pointer-events: none;
  white-space: nowrap;
  z-index: 1;
  transform: ${({ placement }) =>
    placement === 'right' ? 'translateY(-50%)' : 'translateX(-50%)'};
`;

interface ContainerProps {
  isCollapsed?: boolean;
}

export const Container = styled(Box).attrs<ContainerProps>(
  ({ isCollapsed }) => ({
    backgroundColor: 'foreground',
    justify: isCollapsed ? 'flex-start' : 'flex-end',
    align: isCollapsed ? 'flex-start' : 'center',
    pr: 3,
    horizontal: !isCollapsed,
  }),
)<ContainerProps>`
  ${({ isCollapsed }) =>
    isCollapsed &&
    `
    height: 100%;
    gap: 8px;
    padding-top: 16px;

    > * {
      margin-top: 0;
    }

    > #action-bar-item-collapse {
      margin-top: 10px;
    }

    ${TooltipChild} {
      bottom: auto;
      left: 110%;
      top: 50%;
      transform: translateY(-50%);
    }
  `}

  ${({ isCollapsed }) =>
    !isCollapsed &&
    `
    > * {
      margin-left: 2px;
    }

    > #action-bar-item-collapse {
      margin-left: 10px;
      margin-right: auto;

      @media (max-width: ${BP_LAPTOP}px) {
        display: none;
      }

      ${TooltipChild} {
        bottom: auto;
        left: 110%;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    ${TooltipChild} {
      bottom: 110%;
      left: 50%;
    }
  `}
`;

interface IconWrapperProps {
  isActive?: boolean;
  iconWidth?: string | number;
  color?: string;
}

export const IconWrapper = styled(Box).attrs<IconWrapperProps>(
  ({ isActive, iconWidth, color = 'secondaryLink' }) => ({
    color: isActive ? 'primaryBase' : color,
    backgroundColor: 'foreground',
    justify: 'center',
    align: 'center',
    width: iconWidth,
    flexDirection: 'column',
    gap: '4px',
  }),
)<IconWrapperProps>`
  cursor: pointer;
`;

export const ToolTip = styled(Box).attrs(() => ({
  position: 'relative',
}))``;

export const Spacer = styled(Box).attrs({
  height: '10px',
})``;
